export const isTargetEqual = (e, $elem) => {
  return e.target === $elem || e.originalTarget === $elem;
};
export const getTargetByAttribute = (e, attr) => {
  if (e.target.hasAttribute(attr)) {
    return e.target;
  }
  if (e.originalTarget?.hasAttribute(attr) === true) {
    return e.originalTarget;
  }
  return null;
};
export const getTargetAttribute = (e, attr) => {
  return e.target.getAttribute(attr) ?? e.originalTarget?.getAttribute(attr) ?? null;
};
export const getTargetIndexInParent = (e, parent) => {
  const indexOf = Array.prototype.indexOf.call(parent.children, e.target);
  if (indexOf >= 0) {
    return indexOf;
  }
  const origTgt = e.originalTarget;
  if (origTgt != null) {
    return Array.prototype.indexOf.call(parent.children, origTgt);
  }
  return -1;
};